export default __webpack_public_path__ + "static/media/Black Water Disposal - Grey.97c025c1.svg";